import React, { useEffect } from 'react';
import { Header } from './components/sections/Header';
import { Hero } from './components/sections/Hero';
import { TrustBar } from './components/sections/TrustBar';
import { About } from './components/sections/About';
import { Services } from './components/sections/Services';
import { WhyAndrea } from './components/sections/WhyAndrea';
import { Companies } from './components/sections/Companies';
import { Education } from './components/sections/Education';
import { Testimonials } from './components/sections/Testimonials';
import { HowItWorks } from './components/sections/HowItWorks';
import { Appointment } from './components/sections/Appointment';
import { FinalCTA } from './components/sections/FinalCTA';
import { Contact } from './components/sections/Contact';
import { Footer } from './components/sections/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
const META_DESCRIPTION = 'Asesora de seguros especializada en seguros de vida, salud y suplementales. Conoce tus opciones y recibe orientación personalizada.';
export function App() {
  useEffect(() => {
    document.title = 'Andrea Báez Graterol | Seguros de Vida, Salud y Suplementales';
    document.documentElement.lang = 'es';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
  }, []);
  return <div className="min-h-screen w-full bg-cream font-body" data-id="element-0" data-mp="33lwywc6oagx5">
      <a href="#inicio" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-teal focus:px-5 focus:py-3 focus:text-[12px] focus:font-semibold focus:text-white" data-id="element-1" data-mp="33oi0r16z0wuw">
        Saltar al contenido
      </a>
      <Header data-id="element-2" data-mp="nxn69ujvv7of" />
      <main data-id="element-3" data-mp="nxx0jubyo0zx">
        <Hero data-id="element-4" data-mp="sudkecc4nt77" />
        <TrustBar data-id="element-5" data-mp="stue5svuat90" />
        <About data-id="element-6" data-mp="stc9c7v436ph" />
        <Services data-id="element-7" data-mp="st2k4mhw53ku" />
        <WhyAndrea data-id="element-8" data-mp="swgkxqawp4q6" />
        <Companies data-id="element-9" data-mp="3684hdq2uasw" />
        <Education data-id="element-10" data-mp="35ox2qy1z4t4" />
        <Testimonials data-id="element-11" data-mp="356r32ll9c80" />
        <HowItWorks data-id="element-12" data-mp="38kwkjpju1jo" />
        <Appointment data-id="element-13" data-mp="3uct25gan0gyw" />
        <FinalCTA data-id="element-14" data-mp="3udazkg91d18e" />
        <Contact data-id="element-15" data-mp="3ubriwojgwo63" />
      </main>
      <Footer data-id="element-16" data-mp="3uevrrz7vo833" />
      <FloatingWhatsApp data-id="element-17" data-mp="3uf5m1yzyh1el" />
    </div>;
}